import { CellProps, Column } from 'react-table';
import clsx from 'clsx';

import { Device } from '@/core/hostmanagement/open-amt/model';

export const status: Column<Device> = {
  Header: 'Состояние MPS',
  id: 'status',
  disableFilters: true,
  canHide: true,
  sortType: 'string',
  Cell: StatusCell,
  Filter: () => null,
};

export function StatusCell({ row: { original: device } }: CellProps<Device>) {
  return (
    <span className={clsx({ 'text-success': device.connectionStatus })}>
      {device.connectionStatus ? 'Connected' : 'Disconnected'}
    </span>
  );
}
